import {
  Component,
  Input,
  Output, ViewChild, Directive, TemplateRef
} from '@angular/core';
import {I18nPluralPipe} from '@angular/common';
import {element} from 'protractor';


/**
 * The stepnavigation item represents an item that is rendered inside the step navigation component
 **/

@Directive({
  selector: 'ng-template[clo-step-navigation-item]'
})

export class CloStepNavigationItem {

  /**
   * The Title of the step navigation item
   */
  @Input() title: string;

  /**
   * The Subtitle of the step navigation item:
   * If this includes a date, send this as "Status change date"
   * Without the colon
   */
  @Input() subtitle: string;

  /**
   * The date (if any) to attach to the subtitle
   */
  @Input() date: string;

  /**
   * Set this to 'true' if this is the selected state
   */
  @Input() selected = false;


  /**
   * Set this to 'true' if the state is complete
   */
  @Input() completed = false;

  constructor(public templateRef: TemplateRef<any>) { }

  setSelected(state: boolean) {
    this.selected = state;
  }

}
